(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["crosight-trike-guide-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('crosight-trike-guide')) {
    class CrosightTrikeGuide extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;

        this._initialized = true;
        this._dialog = this.querySelector('[data-crosight-guide-dialog]');
        this._closeButton = this.querySelector('[data-crosight-guide-close]');
        this._scroll = this.querySelector('[data-crosight-guide-scroll]');
        this._abortController = new AbortController();

        if (!this._dialog) return;

        const signal = this._abortController.signal;

        document.addEventListener('click', (event) => this._handleDocumentClick(event), { signal });
        this._dialog.addEventListener('click', (event) => this._handleDialogClick(event), { signal });
        this._dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        }, { signal });
        this._dialog.addEventListener('close', () => this._handleClosed(), { signal });
        this._closeButton?.addEventListener('click', () => this.close(), { signal });
      }

      disconnectedCallback() {
        this._abortController?.abort();
        if (this._dialog?.open) this._dialog.close();
        this._initialized = false;
      }

      _handleDocumentClick(event) {
        if (!(event.target instanceof Element)) return;

        const trigger = event.target.closest('[data-crosight-guide-open]');
        if (trigger) {
          event.preventDefault();
          event.stopPropagation();
          this.open(trigger);
          return;
        }

        const tab = event.target.closest('[data-crosight-guide-tab]');
        if (tab && this._dialog.contains(tab)) {
          this._selectTab(tab.dataset.crosightGuideTab);
        }
      }

      _handleDialogClick(event) {
        if (event.target !== this._dialog) return;

        const rect = this._dialog.getBoundingClientRect();
        const isOutside =
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom;

        if (isOutside) this.close();
      }

      open(trigger) {
        if (this._dialog.open) return;

        this._activeTrigger = trigger;
        document.querySelectorAll('[data-crosight-guide-open]').forEach((button) => {
          button.setAttribute('aria-expanded', String(button === trigger));
        });
        this._dialog.showModal();
        if (this._scroll) this._scroll.scrollTop = 0;
        requestAnimationFrame(() => this._closeButton?.focus({ preventScroll: true }));
      }

      close() {
        if (!this._dialog.open) return;

        this._dialog.close();
      }

      _handleClosed() {
        document.querySelectorAll('[data-crosight-guide-open]').forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
        });

        if (this._activeTrigger?.isConnected && this._activeTrigger.getClientRects().length) {
          this._activeTrigger.focus({ preventScroll: true });
        }
      }

      _selectTab(tabName) {
        if (!tabName) return;

        this.querySelectorAll('[data-crosight-guide-tab]').forEach((tab) => {
          const isSelected = tab.dataset.crosightGuideTab === tabName;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.tabIndex = isSelected ? 0 : -1;
        });

        this.querySelectorAll('[data-crosight-guide-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.crosightGuidePanel !== tabName;
        });

        if (this._scroll) this._scroll.scrollTop = 0;
      }
    }

    customElements.define('crosight-trike-guide', CrosightTrikeGuide);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-rating"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('crosight-review-summary')) {
    class CroSightReviewSummary extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;
        this._button = this.querySelector('[data-review-trigger]');
        this._popover = this.querySelector('[data-review-popover]');
        this._closeButton = this.querySelector('[data-review-close]');
        this._relatedToggle = this.querySelector('[data-related-stores-toggle]');
        this._relatedPanel = this.querySelector('[data-related-stores-panel]');
        this._variantText = this.querySelector('[data-review-variant]');
        this._variants = this._parseVariants();
        this._scope = this.closest('product-card, .custom-product-card, .product-info') || this.parentElement;
        this._abortController = new AbortController();
        this._closeTimer = null;

        if (!this._button || !this._popover) return;

        const signal = this._abortController.signal;
        const panelId = `crosight-review-popover-${CroSightReviewSummary.nextId++}`;
        this._popover.id = panelId;
        this._button.setAttribute('aria-controls', panelId);

        if (this._relatedToggle && this._relatedPanel) {
          const relatedPanelId = `${panelId}-related-stores`;
          this._relatedPanel.id = relatedPanelId;
          this._relatedToggle.setAttribute('aria-controls', relatedPanelId);
          this._relatedToggle.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this._setRelatedExpanded(this._relatedToggle.getAttribute('aria-expanded') !== 'true');
          }, { signal });
        }

        this._button.addEventListener('pointerdown', () => {
          this._wasOpenOnPointerDown = this._popover.matches(':popover-open');
        }, { signal });

        this._button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          const wasOpen = this._popover.matches(':popover-open') || this._wasOpenOnPointerDown;
          this._wasOpenOnPointerDown = false;

          if (isMobile && wasOpen) {
            this.close(true);
          } else {
            this.open(true);
          }
        }, { signal });

        this._closeButton?.addEventListener('click', () => this.close(true), { signal });
        this._popover.addEventListener('toggle', () => this._syncOpenState(), { signal });

        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          this.addEventListener('pointerenter', () => this.open(), { signal });
          this.addEventListener('pointerleave', () => this._scheduleClose(), { signal });
          this._popover.addEventListener('pointerenter', () => this._cancelClose(), { signal });
          this._popover.addEventListener('pointerleave', () => this._scheduleClose(), { signal });
        }

        this._scope?.addEventListener('change', () => this._scheduleVariantUpdate(), { signal });
        this._scope?.addEventListener('click', () => this._scheduleVariantUpdate(), { signal });
        if (this._scope) {
          this._variantObserver = new MutationObserver(() => this._scheduleVariantUpdate());
          this._scope
            .querySelectorAll('[data-option-position][data-variant-option-value], input[data-option-position], input[name="id"]')
            .forEach((control) => {
              this._variantObserver.observe(control, {
                attributes: true,
                attributeFilter: ['class', 'checked', 'value']
              });
          });
        }
        window.addEventListener('resize', () => this._position(), { signal, passive: true });
        window.addEventListener('scroll', () => this._position(), { signal, passive: true });
        this._updateVariant();
      }

      disconnectedCallback() {
        this._abortController?.abort();
        this._variantObserver?.disconnect();
        window.clearTimeout(this._variantUpdateTimer);
        this._cancelClose();
        this._initialized = false;
      }

      open(focusPanel = false) {
        this._cancelClose();
        if (!this._popover.matches(':popover-open')) {
          this._popover.showPopover();
        }
        this.setAttribute('open', '');
        this._button.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => {
          this._position();
          if (focusPanel) this._closeButton?.focus({ preventScroll: true });
        });
      }

      close(restoreFocus = false) {
        this._cancelClose();
        if (this._popover.matches(':popover-open')) {
          this._popover.hidePopover();
        }
        this.removeAttribute('open');
        this._button.setAttribute('aria-expanded', 'false');
        this._setRelatedExpanded(false);
        if (restoreFocus) this._button.focus({ preventScroll: true });
      }

      _setRelatedExpanded(expanded) {
        if (!this._relatedToggle || !this._relatedPanel) return;
        this._relatedToggle.setAttribute('aria-expanded', String(expanded));
        this._relatedPanel.hidden = !expanded;
      }

      _syncOpenState() {
        const isOpen = this._popover.matches(':popover-open');
        this.toggleAttribute('open', isOpen);
        this._button.setAttribute('aria-expanded', String(isOpen));
        if (!isOpen) this._setRelatedExpanded(false);
      }

      _scheduleClose() {
        this._cancelClose();
        this._closeTimer = window.setTimeout(() => this.close(), 180);
      }

      _cancelClose() {
        if (this._closeTimer) {
          window.clearTimeout(this._closeTimer);
          this._closeTimer = null;
        }
      }

      _position() {
        if (!this.hasAttribute('open') || window.matchMedia('(max-width: 749px)').matches) return;
        const triggerRect = this._button.getBoundingClientRect();
        const panelRect = this._popover.getBoundingClientRect();
        const gap = 8;
        const edge = 12;
        let left = triggerRect.left;
        let top = triggerRect.bottom + gap;

        left = Math.min(left, window.innerWidth - panelRect.width - edge);
        left = Math.max(edge, left);

        if (top + panelRect.height > window.innerHeight - edge) {
          top = triggerRect.top - panelRect.height - gap;
        }

        top = Math.max(edge, top);
        this._popover.style.left = `${Math.round(left)}px`;
        this._popover.style.top = `${Math.round(top)}px`;
      }

      _parseVariants() {
        const script = this.querySelector('[data-review-variants]');
        try {
          return script ? JSON.parse(script.textContent || '[]') : [];
        } catch (error) {
          return [];
        }
      }

      _scheduleVariantUpdate() {
        window.clearTimeout(this._variantUpdateTimer);
        this._variantUpdateTimer = window.setTimeout(() => this._updateVariant(), 80);
      }

      _updateVariant() {
        if (!this._variantText || !this._scope) return;
        const variant = this._findSelectedVariant();
        const fallback = this.dataset.initialVariant || '';
        const label = variant?.public_title || variant?.title || fallback;
        const normalized = label === 'Default Title' ? '' : label;

        if (normalized) {
          this._variantText.textContent = normalized;
          this._variantText.hidden = false;
        } else {
          this._variantText.hidden = true;
        }
      }

      _findSelectedVariant() {
        if (!this._variants.length) return null;

        const initialVariant = this._variants.find(
          (variant) => String(variant.id) === String(this.dataset.initialVariantId || '')
        ) || null;
        const selections = new Map();
        this._scope.querySelectorAll('[data-option-position][data-variant-option-value].is-active').forEach((control) => {
          selections.set(Number(control.dataset.optionPosition), control.dataset.variantOptionValue || '');
        });
        this._scope.querySelectorAll('input[data-option-position]:checked').forEach((input) => {
          const associatedLabel = input.id ? this._scope.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
          const value = input.dataset.optionValue || associatedLabel?.textContent?.trim() || input.value;
          selections.set(Number(input.dataset.optionPosition), value);
        });

        if (selections.size) {
          initialVariant?.options?.forEach((value, index) => {
            const position = index + 1;
            if (!selections.has(position)) selections.set(position, value);
          });
          const selectionMatch = this._variants.find((variant) => {
            return Array.from(selections.entries()).every(([position, value]) => {
              const optionValue = variant[`option${position}`] || variant.options?.[position - 1] || '';
              return this._normalize(optionValue) === this._normalize(value);
            });
          });
          if (selectionMatch) return selectionMatch;
        }

        const idInput = this._scope.querySelector('input[name="id"]');
        const idVariant = idInput
          ? this._variants.find((variant) => String(variant.id) === String(idInput.value)) || null
          : null;
        return idVariant || initialVariant;
      }

      _normalize(value) {
        return String(value || '').trim().toLowerCase();
      }
    }

    CroSightReviewSummary.nextId = 1;
    customElements.define('crosight-review-summary', CroSightReviewSummary);
  }
  } catch(e) { console.error(e); }
})();

})();
